const fetch = require("node-fetch");

// Warning /!\ use this endpoint: /api/unstable/graphql.json
export const SHOPIFYURL = `${window.shopUrl}/api/2022-01/graphql.json`;

export async function shopifyFetch({ query, variables }) {

    // Check for store front access token
    if (!window.storefrontAccessToken) {
        return console.error("You need a Storefront Access Token");
    }

    try {
        // Fetch data
        const result = await fetch(SHOPIFYURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": window.storefrontAccessToken,
            },
            body: JSON.stringify({ query, variables }),

        }).then((res) => res.json());


        // Show api error
        if (result.errors) {
            console.log('%c [shopifyFetch - result]', 'color: #ffb30f', { errors: result.errors });
        } else if (!result || !result.data) {
            console.log('%c [shopifyFetch - result] - No results found.', 'color: #ffb30f', { result });
            return "No results found.";
        }

        // Return data
        return result.data;
    
    // Show Fetch error
    } catch (error) {
        console.log('%c [shopifyFetch]', 'color: #fd151b', error);
    }
}